<div
  class="mb-4 flex justify-between text-title-medium text-on-surface-variant"
  *transloco="let t; prefix: 'shared.betaFeature.section'"
>
  <span>{{ t('header') }}</span>
  <cdba-beta-feature-badge contentType="general"></cdba-beta-feature-badge>
</div>

<ng-template #highFiveDialog>
  <div
    class="flex flex-col items-center justify-center p-6 text-center"
    (click)="onHighFiveClick()"
    (keydown)="onHighFiveClick()"
    *transloco="let t; prefix: 'shared.betaFeature.section.highFiveDialog'"
  >
    <div class="flex flex-col mb-8">
      <h4 class="font-bold text-xl">{{ t('title') }}</h4>
      <h5 class="text-lg">{{ t('content') }}</h5>
      <h6 class="cursor-pointer text-link text-lg">CDBA</h6>
    </div>
    <div class="animate-bounce">
      <h5 class="text-[50px]">🙌 🙌 🙌</h5>
    </div>
  </div>
</ng-template>

@if (showPricingToggle) {
  <ng-container
    *transloco="let t; prefix: 'shared.betaFeature.section.feature.pricing'"
  >
    <div class="mb-2 text-subtitle-1">{{ t('header') }}</div>
    <div class="mb-2 text-caption">
      {{ t('content') }} <br />
      {{ t('footer') }}
    </div>
    <mat-slide-toggle
      color="primary"
      [checked]="pricingActivated"
      [disabled]="disableToggles"
      (change)="onPricingToggleChange($event)"
    >
      {{ t('activate') }}
    </mat-slide-toggle>
  </ng-container>
}
